import LayoutActividad from "../../../components/LayoutActividad";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { modulo10 } from "../../../routes/Module10";
import Sidebar from "../Sidebar";
import GuiaDocente from "../../../components/GuiaDocente";
import Modulo10Act1 from "../../../DnD/modulo10Act1";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo10/Actividad 1.mp3";

const Actividad1 = () => {
  const infoUnidad = modulo10.content[0];
  const infoAct = modulo10.content[0].activities[0];
  const crumbs = [
    {
      title: modulo10.title,
      url: "/" + modulo10.url,
    },
    {
      title:
        modulo10.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titleNext: `${modulo10.content[0].activities[1].name}`,
    linkNext: `${modulo10.url}/${modulo10.content[0].path}/${modulo10.content[0].activities[1].path}`,
    titlePrev: modulo10.title,
    linkPrev: modulo10.url,
  };
  const metadata = {
    color: modulo10.color,
    title: `${modulo10.title} - ${infoAct.name}`,
    name: modulo10.title,
  };

  const items = [
    <div className="selectable btn btn-blue shadow mx-3 my-1">Piura</div>,
    <div className="selectable btn btn-blue shadow mx-3 my-1">Lima</div>,
    <div className="selectable btn btn-blue shadow mx-3 my-1">Puno</div>,
    <div className="selectable btn btn-blue shadow mx-3 my-1">Loreto</div>,
  ];

  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <div className="row mb-3">
        <div className="col-lg-8 col-12">
          <p>
            <small className={`c-${modulo10.color} hat-text`}>
              <FontAwesomeIcon icon={faEye} /> Observamos
            </small>
          </p>
          <h2 className="mb-5">{infoAct.name}</h2>
          <AudioPlayer track={Audio} />
          <ul>
            <li>
              El Congreso está conformado por 130 congresistas de todas las
              regiones del país.
            </li>
            <li>
              Observa las siguientes imágenes. ¿A qué regiones crees que
              representan los siguientes congresistas? Mueve los nombres de las
              regiones hacia el espacio que corresponda.
            </li>
          </ul>
        </div>
      </div>
      <Modulo10Act1 items={items} />

      <GuiaDocente>
        <p>
          Observen las imágenes. Ayude a identificar las regiones a partir de
          los paisajes que se observan. Destaque que todas las regiones se
          encuentran representadas en el Congreso. Destaque también la
          diversidad de los congresistas (edad, procedencia, género) que
          representan a los ciudadanos.
        </p>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad1;
